import type from './constants';

export default {
    saveSearchParams: (params) => ({
        type: type.SAVE_SEARCH_PARAMS,
        params,
    }),
    savePagination: (params) => ({
        type: type.SAVE_PAGINATION,
        params,
    }),
    updateClearState: () => ({
        type: type.UPDATE_CLEAR_STATE,
    }),
    updateUseState: () => ({
        type: type.UPDATE_USE_STATE,
    })
};


// WEBPACK FOOTER //
// ./src/components/manHour/query/store/actions.js